// extracted by mini-css-extract-plugin
export default {"cardContainer":"card_cardContainer__fXPK2","favourite":"card_favourite__M-Y-p"};